<template>
  <div class="qfjl">
    <van-nav-bar
        title="欠费记录"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <div class="margin0"/>

    <van-cell v-model="C_Code" icon="user-circle-o" size="large" >
      <!-- 使用 title 插槽来自定义标题 -->
      <template #title>
        <span class="custom-title">{{C_Name}}</span>
      </template>
    </van-cell>
    <van-cell  icon="wap-home-o">
      <template #title>
        <span class="custom-title2">{{C_Address}}</span>
      </template>
    </van-cell>

    <div class="margin1"/>




    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <van-cell-group v-for="(item,index) in list" :key="item.id" @click="faDetail(index)" >
          <van-cell  v-model="item.FA_NDate" icon="calendar-o" size="large" is-link>
            <!-- 使用 title 插槽来自定义标题 -->
            <template #title>
              <span class="custom-title">抄表日期  </span>
              <van-tag v-if="item.FA_Flag === '销账'" type="success">{{item.FA_Flag}}</van-tag>
              <van-tag v-if="item.FA_Flag === '欠费'" type="danger">{{item.FA_Flag}}</van-tag>
              <van-tag v-if="item.FA_Flag === '扣费途中'" type="warning">{{item.FA_Flag}}</van-tag>
              <van-tag v-if="item.FA_Flag === '微信扣费中'" type="warning">{{item.FA_Flag}}</van-tag>
            </template>
          </van-cell>
          <van-cell title="用气量" v-model="item.FA_Count" icon="bar-chart-o"/>
<!--          <van-cell title="总气费" v-model="item.FA_Fee" icon="gold-coin-o"/>
          <van-cell title="违约金" v-model="item.FA_LateFee" icon="refund-o"/>
          <van-cell title="已缴气费" v-model="item.FA_Pay" icon="points"/>-->
          <van-cell title="待缴费" v-model="item.FA_Owe" icon="balance-o"/>
        </van-cell-group>

      </van-list>
    </van-pull-refresh>



    <van-submit-bar v-if="totalfee===0"  disabled :price="totalfee * 100" button-text="已销账"/>
    <van-submit-bar v-if="totalfee!==0"   :price="totalfee * 100" button-text="去付款" @submit="checkOrder" />

  </div>
</template>
<script>
import API from './../api/index';
import {Toast} from "vant";
//import { Toast } from 'vant';
export default {
  name: 'page_qfjl',
  data() {
    return {
      C_ID:"",
      C_Code:"",
      C_Name:"",
      C_Address:"",
      list: [],
      totalfee:0,
      faidstr:"",
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    },
    getCust() {
      if (this.$cookie.get('CID')===''||!this.$cookie.get('CID')) {
        Toast('请先绑定用户！')
        this.$router.push('/bindlist');
      } else {
        this.C_ID=this.$cookie.get('CID');
        this.C_Code=this.$cookie.get('C_Code');
        this.C_Address=this.$cookie.get('CAddress');
        this.C_Name=this.$cookie.get('CName');
      }

    },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }

        this.$http.get(API.LookOweListByWX,{
          params: {
            c_id:this.C_ID
          }
        })
            .then((response)=>{
              let res = response.data;
              if (res.code == 0) {
                this.list=res.subdata;
                this.$cookie.set('feeall',res.subdata,  { expires: '360m' });
                //this.$cookie.set('totalfee',res.totalfee,  { expires: '360m' });
                //this.$cookie.set('faidstr',res.faidstr,  { expires: '360m' });
                this.totalfee=res.totalfee;
                this.faidstr=res.faidstr;
              } else {
                this.loading = false;
                this.finished= true;
              }
            });

        this.loading = false;

        if (this.list.length) {
          this.finished = true;
        }
      }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    faDetail (index) {
      this.$cookie.set('fa_index',index,  { expires: '360m' });
      this.$router.push('/feeall');
    },
    checkOrder() {
      Toast.loading({
        message: '请稍候...',
        forbidClick: true,
        duration: 0 ,
      });
      this.$http.get(API.CheckFeeAll,{
        params: {
          C_ID:this.C_ID,
          totalfee:this.totalfee,
          faidstr:this.faidstr
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code === 0) {
              this.order();
              //Toast('11111111')
            } else {
              Toast.clear();
              Toast('费用产生变化，请刷新重试');
              this.$router.go(0);
            }
          });
    },
    order() {
      this.$http.get(API.FeeAllOrder,{
        params: {
          C_ID:this.C_ID,
          totalfee:this.totalfee,
          faidstr:this.faidstr
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code === 0) {
              this.WP_ID = res.message;
              //Toast(res.message)
              this.searchOrder();
            } else {
              Toast.clear();
            }
          });

    },
    searchOrder() {
      let _this=this
      setTimeout(function () {
        _this.searchOrderFunction();
      },500)
    },
    searchOrderFunction() {
      this.$http.get(API.searchOrder,{
        params: {
          WP_ID:this.WP_ID
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code === 0) {
              if (res.WP_Flag == 1) {
                console.log('准备调用微信支付1.2')
                this.searchOrder();
              } else if (res.WP_Flag == 3) {
                console.log('准备调用微信支付1.1')
                //Toast('准备调用微信支付1.1');
                this.orderPay(res);
              } else if (res.WP_Flag == 0) {

                console.log('准备调用微信支付1.3')
                this.searchOrder();
              } else {
                console.log('准备调用微信支付1.4')
                Toast.clear();
                Toast('下单失败，请稍候重试')
              }

            } else {
              console.log('准备调用微信支付1.5')
              Toast.clear();
              Toast('下单失败，请稍候重试')
            }
          });
    },
    orderPay(res) {
      console.log('准备调用微信支付2')
      //Toast('准备调用微信支付2')
      let vm = this
      if (typeof WeixinJSBridge === 'undefined') { // 微信浏览器内置对象。参考微信官方文档
        console.log('准备调用微信支付3.1')
        //Toast()
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(res), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(res))
          document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(res))
        }
      } else {
        console.log('准备调用微信支付3.2')
        vm.onBridgeReady(res)
      }
    },
    onBridgeReady (data) {
      console.log('调用微信支付WeixinJSBridge')
      var vm = this
      WeixinJSBridge.invoke(
          'getBrandWCPayRequest', { // 下面参数内容都是后台返回的
            'appId': data.WP_appId, // 公众号名称，由商户传入
            'timeStamp': data.WP_timeStamp, // 时间戳
            'nonceStr': data.WP_nonceStr, // 随机串
            'package': data.WP_package, // 预支付id
            'signType': data.WP_signType, // 微信签名方式
            'paySign': data.WP_paySign // 微信签名
          },
          function (res) {
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            if (res.err_msg === 'get_brand_wcpay_request:ok') {

              vm.$http.get(API.PayADSus,{
                params: {
                  WP_ID:vm.WP_ID
                }
              })
                  .then((response)=>{
                    let res = response.data;
                    if (res.code === 0) {
                      Toast.clear();
                      Toast('支付成功');
                      vm.$router.push('/ybsf')
                    } else {
                      Toast.clear();
                      Toast('支付成功');
                      vm.$router.push('/ybsf')
                    }
                  });

            } else {
              vm.$http.get(API.PayADFail,{
                params: {
                  WP_ID:vm.WP_ID
                }
              })
                  .then((response)=>{
                    let res = response.data;
                    if (res.code === 0) {
                      Toast.clear();
                      Toast('支付失败，请稍候重试');
                      vm.$router.push('/ybsf')
                    } else {
                      Toast.clear();
                      Toast('支付失败，请稍候重试');
                      vm.$router.push('/ybsf')
                    }
                  });
            }
          }
      )
    },
  },
  mounted () {
    this.getCust();
  }
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
.margin1{
  height: 0.5rem;
  background-color: #f5f5f5;
}
.margin0{
  height: 0.5rem;
  background-color: #f5f5f5;
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}

</style>